/**
 * Splits `text` into segments for search highlighting using Typesense `<mark>` snippets.
 */
export function splitTextForSearchHighlighting(
  text: string,
  _rawQuery: string,
  highlightSnippet?: string,
): Array<{ text: string; highlight: boolean }> {
  if (highlightSnippet) {
    const unescaped = highlightSnippet
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#x27;/g, "'")
      .replace(/&#x60;/g, "`");
    const parts = unescaped.split(/(<mark>.*?<\/mark>)/g);
    return parts
      .filter((p) => p !== "")
      .map((p) => {
        const isHighlight = p.startsWith("<mark>");
        return {
          text: isHighlight ? p.replace(/<\/?mark>/g, "") : p,
          highlight: isHighlight,
        };
      });
  }

  return [{ text: text ?? "", highlight: false }];
}
